export default __webpack_public_path__ + "4d2016cbd2a30495e83e19ea85aca03f.png";